export default __webpack_public_path__ + "media/images/landing-16-550x420-d2f9ce9638949837b73f4427b7b241ad.jpg";